import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../components/Common/calender-icon.css";
import { dateFormat } from "../../Helper/common";

function ADDDate(props) {
  const {
    name,
    id,
    fieldId,
    paramStartDate,
    intialStatus,
    placeholder,
    errId,
    isRequired,
    isDisabled = false,
    hasError,
    saveDate,
    checkDetailsIndex,
    fieldName,
    fieldValue,
    minDateDOL = null,
    maxDOJDate = null,
  } = props;
  const [selectedDate, setSelectedDate] = useState(null);
  const [maxDate, setMaxDate] = useState(null);
  const [minDate, setMinDate] = useState(null);

  useEffect(() => {
    if (!fieldValue) {
      //console.log(inputText?.current?.value, name);
      //inputText.current.value = '';
      setSelectedDate(null);
    }
  }, [fieldValue])

  useEffect(() => {
    if (fieldValue && fieldValue !== "") {
      const [dd, mm, yyyy] = fieldValue.split("-");
      const newVal = `${dd}/${mm}/${yyyy}`;
      const date = dateFormat("DD/MM/YYYY", newVal);
      if (date !== "Invalid date") {
        const newDate = new Date(date);
        setSelectedDate(newDate);
      }
    }

    if (fieldName == "residing_from") {
      const pastDate = new Date();
      pastDate.setDate(pastDate.getDate());
      setMinDate(minDateDOL);
      setMaxDate(pastDate);
    }

    if (fieldName == "residing_since") {
      if (maxDOJDate) {
        setMaxDate(maxDOJDate);
      } else {
        const pastDate = new Date();
        pastDate.setDate(pastDate.getDate() - 1);
        setMaxDate(pastDate);
      }
    }
  }, [fieldValue, minDateDOL, maxDOJDate]);

  const handleThirdPartyFloatingLabel = (e) => {
    let parent = e.target.parentElement;
    while (!parent.classList.contains("floating-label"))
      parent = parent.parentElement;
    if (parent.children[1].classList.contains("focused")) {
      // if (selectedDate !== null) {
      //   console.log(selectedDate, 'line 64');
      //   return false; 
      // } else {
      //   console.log(selectedDate, 'line 67');
      //  parent.children[1].classList.remove("focused");
      // }
    } else {
      parent.children[1].classList.add("focused");
    }
  };

  const dateSelectHandler = (date) => {
    setSelectedDate(date);
    //handleSaveDate(new Date(date).toLocaleDateString());
    let formatedDate = dateFormat("DD/MM/YYYY", date);
    handleSaveDate(formatedDate);
  };

  const handleSaveDate = (selectedDate) => {
    const [day, month, year] = selectedDate.split("/");
    const savedDate = day + "-" + month + "-" + year;
    saveDate(checkDetailsIndex, fieldName, savedDate);
  };

  return (
    <>
      <div className="col-sm-4 col-md-12 col-xl-4">
        <div className="form-group">
          <div className="floating-label has-left-icon react-date-picker">
            <DatePicker
              className="form-control calendar-icon"
              selected={selectedDate}
              id={props.id}
              dateFormat="dd/MM/yyyy"
              onChange={(date) => dateSelectHandler(date)}
              onFocus={handleThirdPartyFloatingLabel}
              onBlur={handleThirdPartyFloatingLabel}
              autoComplete="off"
              showMonthDropdown={true}
              showYearDropdown={true}
              dropdownMode="select"
              //disabled={isDisabled}
              value={fieldValue}
              maxDate={maxDate}
              minDate={minDate}
              fixedHeight
              onKeyDown={(e) => {
                e.preventDefault();
              }}
            />
            <label htmlFor={props.id} className={(fieldValue || selectedDate) && "focused"}>
              {placeholder}
              {isRequired && <sup className="text-danger">*</sup>}
            </label>
          </div>
          {hasError === true && (
            <p className="err text-danger" id={errId}>
              This field is required.
            </p>
          )}
        </div>
      </div>
    </>
  );
}

export default ADDDate;
